import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import ThreeMonitor from '@/components/XMonitor/Monitor/ThreeMonitor';
import MapMode from '@/components/MapMode';
import debounce from 'lodash/debounce';
import { RootState } from '@/redux/store';
import { clstagStr } from '@/utils/util';
import { CLSTAG } from '@/utils/constant';
import { VehicleTag } from '@/redux/type';
import { useNavigate } from 'react-router-dom';
import qs from 'qs';
interface Props {
  mapData: any;
  license: string;
  handleShowVideo?: AnyFunc;
  handleChangeMapType: AnyFunc;
  toggleStartOrStopVehiclePosition: AnyFunc;
}

const btnArr: any = [
  {
    type: 'mapMode',
    visible: true,
    active: false,
    clstag: clstagStr(CLSTAG.QQMapBtn),
  },
  {
    type: 'threeMode',
    visible: false,
    active: false,
    clstag: clstagStr(CLSTAG.ThreeMonitor),
  },
  {
    type: 'angle_p',
    visible: true,
    active: false,
    clstag: clstagStr(CLSTAG.SinglePage_3DAngle_P),
  },
  {
    type: 'angle_t',
    visible: true,
    active: true,
    clstag: clstagStr(CLSTAG.SinglePage_3DAngle_T),
  },
  {
    type: 'angle_f',
    visible: true,
    active: false,
    clstag: clstagStr(CLSTAG.SinglePage_3DAngle_F),
  },
];

const angleArr = ['angle_p', 'angle_t', 'angle_f'];

const MonitorOne = (props: Props) => {
  const query = qs.parse(window.location.search.split('?')[1]);
  const navigator = useNavigate();
  const userInfo: any = useSelector((state: RootState) => state.login.user);
  const vehicleBasicInfo: any = useSelector(
    (state: RootState) => state.singleVehiclePageInfo.vehicleBasicInfoNew,
  );
  const monitorRef: React.RefObject<ThreeMonitor> = React.createRef();
  const [btnIcons, setBtnIcons] = useState(btnArr);
  const { license, mapData, toggleStartOrStopVehiclePosition } = props;
  useEffect(() => {
    const resizeMonitor = () => {
      const container = document.getElementById('WebGL-output');
      if (container) {
        const width = container.clientWidth;
        const height = container.clientHeight;
        monitorRef.current &&
          monitorRef.current.renderer.setSize(width, height);
      }
    };
    const _debounce = debounce(resizeMonitor, 500);
    window.addEventListener('resize', _debounce);
    return () => {
      window.removeEventListener('resize', _debounce);
    };
  }, [props]);

  const toggleMapMode = (type: string) => {
    const node = document.getElementById('WebGL-output');
    if (node) {
      node.style.display = type === 'mapMode' ? 'none' : 'block';
      if (type === 'threeMode') {
        toggleStartOrStopVehiclePosition('STOP');
        monitorRef.current!.switchCamera(0);
      } else if (type === 'mapMode') {
        toggleStartOrStopVehiclePosition('START');
      }
    }
  };

  const toggleVisualAngle = (index: number) => {
    monitorRef.current!.switchCamera(index);
  };

  const handleBtnClick = (type: string) => {
    if (type.indexOf('angle_') > -1) {
      const index = angleArr.indexOf(type);
      toggleVisualAngle(index);
    } else {
      toggleMapMode(type);
    }
    const btns = [...btnIcons];
    btns.forEach((item: any) => {
      item.active = item.type === type;
      if (type === 'mapMode') {
        item.visible = item.type.indexOf('angle_') === -1;
      } else if (type === 'threeMode') {
        item.visible = item.type !== type;
        item.active = item.type === 'angle_p';
      }
    });

    setBtnIcons(btns);
    props.handleChangeMapType && props.handleChangeMapType(type);
  };

  const renderControlBtn = (btnList: any[]) => {
    return btnList.map((btn, index) => {
      return (
        <li
          className={`item ${btn.type} ${btn.active ? 'active' : ''}`}
          style={{ display: `${btn.visible ? 'block' : 'none'}` }}
          key={index}
          clstag={clstagStr(btn.clstag)}
          onClick={handleBtnClick.bind(null, btn.type)}
        />
      );
    });
  };
  const isMapMode = btnIcons.find((btn: any) => btn.type === 'mapMode')?.active;
  return (
    <div className='monitor-container'>
      {isMapMode && (
        <MapMode
          mapData={mapData}
          isBeiDou={
            vehicleBasicInfo.tagList &&
            vehicleBasicInfo.tagList.includes(VehicleTag.BEIDOU)
          }
        />
      )}
      {license && userInfo && (
        <ThreeMonitor
          ref={monitorRef}
          carNumber={license}
          url={process.env.JDX_APP_MONITOR_PROXY_URL + license}
        />
      )}

      <ul className='tools'>{renderControlBtn(btnIcons)}</ul>
    </div>
  );
};
export default React.memo(MonitorOne);
